module.exports = __webpack_public_path__ + "static/media/published_with_changes-black-18dp.47a170d1.svg";